
export default function HeroSection() {
  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `url('https://static.readdy.ai/image/47797aaf865cef369d7dc5b454daa997/2d0b036e5e25341f66ed41edae91fd3d.jpeg')`
      }}
    >
      {/* 濃いグラデーションオーバーレイ */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-black/20"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="flex flex-col items-center justify-center min-h-screen">
          {/* テキストコンテンツ */}
          <div className="w-full max-w-4xl text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              企業の成長を
              <span className="text-blue-400 block font-black">戦略的に支援します</span>
            </h1>
            <p className="text-lg md:text-xl text-white/90 mb-8 leading-relaxed max-w-2xl mx-auto drop-shadow-lg">
              豊富な経験と専門知識で、お客様のビジネス課題を解決し、持続可能な成長を実現します。
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:-translate-y-1 whitespace-nowrap cursor-pointer"
              >
                無料相談を予約
              </button>
              <button 
                onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
                className="border-2 border-white/80 text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-gray-900 transition-all duration-300 backdrop-blur-sm whitespace-nowrap cursor-pointer"
              >
                サービス詳細
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
